import React, { useContext, useEffect } from "react";

/// React router dom
import {
  Routes,
  Route,
  Outlet,
  Navigate,
  BrowserRouter,
} from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
//import Main from './layouts/Main';

import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import Home from "../pages/dashboard/home";




/// Pages

import LockScreen from "../pages/authentication/lockScreen";
import Error400 from "../pages/errorPages/error400";
import Error403 from "../pages/errorPages/error403";
import Error404 from "../pages/errorPages/error404";
import Error500 from "../pages/errorPages/error500";
import Error503 from "../pages/errorPages/error503";
import { ThemeContext } from "../context/ThemeContext";
import Login from "../pages/authentication/login";
import { useDispatch, useSelector } from "react-redux";
import { authenticate } from "../feature/authSlice";
import NotificationPage from "../pages/notificationPage/notificationPage.js";
import ServiceRequests from "../pages/serviceRequests/serviceRequests";
import SignUp from "../pages/authentication/signUp";
import SignUpCustomer from "../pages/authentication/signUpCustomer";
import SignUpPro from "../pages/authentication/signUpPro";
import SendVideoLink from "../pages/sendVideoLink/sendVideoLink";
import UserProfile from "../pages/userProfile/userProfile";
import AdminDashboard from "../pages/adminDashboard/adminDashboard";
import WaitingUserDashboard from "../pages/waitingUserDashboard/waitingUserDashboard";
import FeedbackListForAdmin from "../pages/feedbackList/feedbackListForAdmin";
import Scan from "../pages/scan/scan";
import ForgotPassword from "../pages/authentication/forgotPassword";
import VideoChat from "../pages/twilio/videoChat";
import ResetPassword from "../pages/authentication/resetPassword";
import CreatePassword from "../pages/authentication/createPasswordFirstTime";
import DeepLinking from "../pages/deepLinking/deepLinking";
import VerifyEmailPhone from "../pages/authentication/verifyEmailPhone";
import CallHistory from "../pages/callHistory/callHistory";
import Subscription from "../pages/subscription/subscription";
import ParticularUserDetailsForAdminPage from "../pages/particularUserDetailsForAdmin/particularUserDetailsForAdminPage";
import CompaniesListForAdmin from "../pages/companies/companyDashboard";
import CallDetailsPage from "../pages/callDetails/callDetailsPage.js";
import PurchaseListDownlaod from "../pages/purchaseListDownload/purchaseList.js";
import ParticularNotificationDetails from "../pages/particularNotificationDetails/particularNotificationDetails.js";
import PermissionDashboard from "../pages/permissionDashboard/permissionDashboard.js";
import ShareableServiceRequest from "../pages/shareableServiceRequest/shareableServiceRequest.js";
import ServiceRequestDetailsPage from "../pages/serviceRequestDetails/serviceRequestDetailsPage.js";
import { useNavigate } from "react-router-dom";
import CallRating from "../pages/twilio/callRating.js";
import TipsAndTricks from "../pages/tipsAndTricks/tipsAndTricks.js";
import ScheduledServiceRequests from "../pages/serviceRequests/scheduledServiceRequests.js";
import OpenServiceRequests from "../pages/serviceRequests/openServiceRequests.js";
import Canvas from "../pages/POC/index.js";
import Refunds from "../pages/refunds/refunds.js";
import HomeMaintenance from "../pages/homeMaintenance/homeMaintenance.js";
import OcrDemo from "../pages/moreTabs/ocrDemo.js";
import RecognizeDemo from "../pages/moreTabs/recognizeDemo.js";
import DrawingDemo from "../pages/moreTabs/drawingDemo.js";
import CheckUpResults from "../pages/homeMaintenance/checkUpResults.js";
import MaintenanceTasks from "../pages/homeMaintenance/maintenanceTasks.js";
import ActivateUser from "../pages/authentication/activateUser.js";
import EarningsPage from "../pages/paymentModule/earningsPage/earningsPage.js";
import SaveCardDetailsPage from "../pages/paymentModule/saveCardDetailsPage/saveCardDetailsPage.js";
import AddAccountDetailsPage from "../pages/paymentModule/addAccountDetailsPage/addAccountDetailsPage.js";
import ManagePromocode from "../pages/adminScreens/managePromocode.js";
import TransactionsList from "../pages/paymentModule/transactionsList/transactionsList.js";
import CompanyInvitation from "../pages/companyInvitation/companyInvitation.js";
import ServicesForAdmin from "../pages/servicesForAdmin/servicesForAdmin.js";
import TransactionsForAdmin from "../pages/transactionsForAdmin/transactionsForAdmin.js";
import AffiliateProgram from "../pages/affiliateProgram/affiliateProgram.js";
import JoinCompany from "../pages/joinCompany/joinCompany.js";
import CompanyRequests from "../pages/companyRequests/companyRequests.js";
import CompanyManagement from "../pages/companyManagement/companyManagement.js";
import UserLogs from "../pages/adminReportings/userLogs.js";
import ServiceLogs from "../pages/adminReportings/serviceLogs.js";
import NewProDashboard from "../pages/dashboard/newProDashboard/newProDashboard.js";
import FreehandDrawing from "../pages/DEMO";
import ScheduleCallDownload from "../pages/scheduleCallDownload/scheduleCallDownload.js";
import DIYproject from "../pages/DIYproject/DIYproject.js";
import GuestLoginLink from "../pages/guestLogins/guestLogins.js";
import MyDIYProject from "../pages/DIYproject/diyProjectListing.js";
import CallRecordings from "../pages/callRecordings/callRecordings.js";
import SendNotificationsByAdmin from "../pages/sendNotificationsByAdmin/sendNotificationsByAdmin.js";
import { setDownloadAppBar } from "../feature/userData/userData.js";
import DownloadAppBanner from "../component/downloadAppBanner/downloadAppBanner.js";
import NewScanFlow from "../pages/scan/newScanFlow.js";
import AddLink from "../pages/addLink/addLink.js";
import AddLinkNew from "../pages/addLink/addLinkNew.js";
import LocalProDashboard from "../pages/dashboard/localProDashboard/localProDashboard.js";
import Estimate from "../pages/scan/estimate.js";


const Markup = () => {
  const {
    permissionArr = [],
    companyId,
    role,
    downloadAppBar,
    isActiveCall,
    proOptionFlag,
  } = useSelector((state) => state.user) ?? {};
  const { totalEarned } = useSelector((state) => state.finance) ?? {};

  const tabPermission =
    (Array.isArray(permissionArr) && permissionArr[0]) || [];

  const allroutes = [
    // Auth

    /// Dashboard
    { url: "", component: tabPermission.includes("HOME TAB") ? <Home /> : <TipsAndTricks /> },
    { url: "dashboard", component: <Home /> },
    (tabPermission.includes("SERVICE REQUEST TAB") || tabPermission.includes("ASSIGN SERVICE REQUEST")) && { url: "serviceRequest", component: <ServiceRequests /> },
    // Service details page permission check removed as per discussion
    // (tabPermission.includes("SERVICE REQUEST TAB") || tabPermission.includes("ASSIGN SERVICE REQUEST")) && { url: "serviceRequestDetails", component: <ServiceRequestDetailsPage /> },
    { url: "serviceRequestDetails", component: <ServiceRequestDetailsPage /> },
    { url: "connect", component: <SendVideoLink /> },
    tabPermission.includes("HOME TAB") && { url: "notificationPage", component: <NotificationPage /> },
    tabPermission.includes("HOME TAB") && { url: "notificationDetails", component: <ParticularNotificationDetails /> },
    tabPermission.includes("PROFILE TAB") && { url: "userProfile", component: <UserProfile /> },
    tabPermission.includes("ADMIN TAB") && { url: "admin", component: <AdminDashboard /> },
    tabPermission.includes("ADMIN TAB") && { url: "waitingUserDashboard", component: <WaitingUserDashboard /> },
    tabPermission.includes("VIEW FEEDBACK LIST") && { url: "admin/feedbackList", component: <FeedbackListForAdmin /> },
    tabPermission.includes("ASSIGN PERMISSION TO ROLE") && { url: "admin/promocode", component: <ManagePromocode /> },
    ((tabPermission.includes("ASSIGN SERVICE REQUEST") && companyId)) && { url: "scan", component: <Scan /> },
    (tabPermission.includes("SCAN TAB")) && { url: "scanNew", component: <NewScanFlow /> },
    (tabPermission.includes("SCAN TAB")) && { url: "addLinkA", component: <AddLink /> },
    (tabPermission.includes("SCAN TAB")) && { url: "addLinkB", component: <AddLinkNew /> },
    // { url: "subscription", component: <Subscription /> },
    tabPermission.includes("ADMIN TAB") && { url: "particularUserDetailsForAdminPage", component: <ParticularUserDetailsForAdminPage /> },
    tabPermission.includes("VIEW REGISTERED COMPANIES LIST") && { url: "admin/registeredCompanies", component: <CompaniesListForAdmin /> },
    (tabPermission.includes("SERVICE REQUEST TAB") || tabPermission.includes("ASSIGN SERVICE REQUEST")) && { url: "callDetails", component: <CallDetailsPage /> },
    tabPermission.includes("ASSIGN PERMISSION TO ROLE") && { url: "admin/permissions", component: <PermissionDashboard /> },
    tabPermission.includes("TIPSANDTRICKS TAB") && { url: "tipsAndTricks", component: <TipsAndTricks /> },
    (tabPermission.includes("SERVICE REQUEST TAB") || tabPermission.includes("ASSIGN SERVICE REQUEST")) && { url: "scheduledServiceRequests", component: <ScheduledServiceRequests /> },
    (tabPermission.includes("SERVICE REQUEST TAB") || tabPermission.includes("ASSIGN SERVICE REQUEST")) && { url: "openServiceRequests", component: <OpenServiceRequests /> },
    { url: "simulator", component: <Canvas /> },
    tabPermission.includes("VIEW REGISTERED COMPANIES LIST") && { url: "admin/refunds", component: <Refunds /> },
    tabPermission.includes("SCAN TAB") && { url: "maintenance", component: <HomeMaintenance /> },
    tabPermission.includes("PLAYGROUND TAB") && { url: "ocrDemo", component: <OcrDemo /> },
    tabPermission.includes("PLAYGROUND TAB") && { url: "recognizeDemo", component: <RecognizeDemo /> },
    tabPermission.includes("PLAYGROUND TAB") && { url: "drawingDemo", component: <DrawingDemo /> },
    tabPermission.includes("SCAN TAB") && { url: "checkUpResults", component: <CheckUpResults /> },
    tabPermission.includes("SCAN TAB") && { url: "maintenanceTasks", component: <MaintenanceTasks /> },
    ((tabPermission.includes("UPDATE WORK INFORMATION") && !companyId) || (tabPermission.includes("UPDATE WORK INFORMATION") && companyId && totalEarned > 0) || (role == 4)) && { url: "earnings", component: <EarningsPage /> },
    // { url: "payments", component: <SaveCardDetailsPage /> },
    // { url: "payouts", component: <AddAccountDetailsPage /> },
    ((tabPermission.includes("UPDATE WORK INFORMATION") && !companyId) || (tabPermission.includes("UPDATE WORK INFORMATION") && companyId && totalEarned > 0) || (role == 4) || tabPermission.includes("SCAN TAB")) && { url: "transactions", component: <TransactionsList /> },
    (tabPermission.includes("VIEW COMPANY SERVICE REQUESTS") || tabPermission.includes("VIEW ALL SERVICE REQUESTS")) && { url: "admin/services", component: <ServicesForAdmin /> },
    tabPermission.includes("FINANCIAL TAB") && { url: "admin/transactions", component: <TransactionsForAdmin /> },
    tabPermission.includes("VIEW REGISTERED COMPANIES LIST") && { url: "admin/affiliateProgram", component: <AffiliateProgram /> },
    ((tabPermission.includes("UPDATE WORK INFORMATION") && !companyId)) && { url: "companyRequests", component: <CompanyRequests /> },
    ((tabPermission.includes("UPDATE WORK INFORMATION")) || (tabPermission.includes("VIEW COMPANY USERS"))) && { url: "companyManagement", component: <CompanyManagement /> },
    { url: "assignService", component: <ServicesForAdmin /> },
    tabPermission.includes("VIEW REGISTERED COMPANIES LIST") && { url: "reports/userLogs", component: <UserLogs /> },
    tabPermission.includes("VIEW REGISTERED COMPANIES LIST") && { url: "reports/serviceLogs", component: <ServiceLogs /> },
    { url: "newDemo", component: <FreehandDrawing /> },
    tabPermission.includes("CREATE PROJECT TAB") && { url: "DIYproject", component: <DIYproject /> },
    tabPermission.includes("ADMIN TAB") && { url: "admin/guestLogin", component: <GuestLoginLink /> },
    (tabPermission.includes("CREATE PROJECT TAB") || tabPermission.includes("ASSIGN SERVICE REQUEST")) && { url: "myDiyProject", component: <MyDIYProject /> },
    tabPermission.includes("UPDATE WORK INFORMATION") && { url: "onBoardPro", component: <NewProDashboard /> },
    // { url: "admin/callRecordings", component: <CallRecordings /> },
    tabPermission.includes("VIEW REGISTERED COMPANIES LIST") && { url: "admin/sendNotifications", component: <SendNotificationsByAdmin /> },
    ((tabPermission.includes("UPDATE WORK INFORMATION") && proOptionFlag == 4) && { url: "localProDashboard", component: <LocalProDashboard /> })
  ];



  const dispatch = useDispatch();
  const { authorized } = useSelector((state) => state.auth);

  if (localStorage.getItem("access_token") && localStorage.getItem("refresh_token") && localStorage.getItem("user_id")) {
    dispatch(authenticate());
  }

  // useEffect(() => {
  //   console.log("downloadAppBar", downloadAppBar);
  //   console.log("isActiveCall", isActiveCall);

  // }, [downloadAppBar, isActiveCall]);

  return (
    <>
      <BrowserRouter>
        <DownloadAppBanner />
        <Routes>
          {/* <Route path='*' element={<Error400/>}/> */}
          <Route path="page-lock-screen" element={<LockScreen />} />
          <Route path="page-error-400" element={<Error400 />} />
          <Route path="page-error-403" element={<Error403 />} />
          <Route path="page-error-404" element={<Error404 />} />
          <Route path="page-error-500" element={<Error500 />} />
          <Route path="page-error-503" element={<Error503 />} />
          <Route path="videoCall" element={<VideoChat />} />
          <Route path="/app" element={<DeepLinking />} />
          <Route path="/purchaseList" element={<PurchaseListDownlaod />} />
          <Route path="/callScheduling" element={<ScheduleCallDownload />} />
          <Route path="/shareableServiceRequest" element={<ShareableServiceRequest />} />
          <Route path="/estimateServiceRequest" element={<ShareableServiceRequest />} />
          <Route path="/callRating" element={<CallRating />} />
          <Route path="/companyInvitation" element={<CompanyInvitation />} />
          <Route path="/scanNew" element={<NewScanFlow />} />
          <Route path="/estimate" element={<Estimate />} />
          <Route path="/addLinkA" element={<AddLink />} />
          <Route path="/addLinkB" element={<AddLinkNew />} />
          {/* <Route path="/maintenanceTasks" element={<MaintenanceTasks />} /> */}
          {/* <Route path="/checkUpResults" element={<CheckUpResults />} /> */}
          {/* <Route path="/joinCompany" element={<JoinCompany />} /> */}

          {!authorized ? (
            <Route element={<Outerlayout />}>
              <Route path="*" element={<Navigate replace to="/login" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/signUpPro" element={<SignUpPro />} />
              <Route path="/signUpPro/try" element={<SignUpPro />} />
              <Route path="/signUpCustomer" element={<SignUpCustomer />} />
              <Route path="/forgotPassword" element={<ForgotPassword />} />
              <Route path="/resetPassword" element={<ResetPassword />} />
              <Route path="/createPassword" element={<CreatePassword />} />
              <Route path="/verifyEmailPhone" element={<VerifyEmailPhone />} />
              <Route path="/activateUsers" element={<ActivateUser />} />
            </Route>
          ) : (
            <>
              <Route element={<MainLayout />}>
                {allroutes.length > 0 &&
                  allroutes.map((data, i) => (
                    <Route
                      key={i}

                      path={`${data?.url}`}
                      element={data?.component}
                    />

                  ))
                }
                <Route path="*" element={<Navigate replace to="/" />} />

              </Route>


            </>
          )}
        </Routes>
        <ScrollToTop />
      </BrowserRouter>
    </>
  );
};

function MainLayout() {
  const navigate = useNavigate();
  const { isActiveCall, downloadAppBar } = useSelector((state) => state.user);

  // useEffect(() => {
  //   navigate("/")
  // }, [])
  const { menuToggle } = useContext(ThemeContext);
  return (
    <div
      id="main-wrapper"
      className={"show"}
    >

      <Nav />
      <div
        className="content-body"
        style={{
          paddingTop: isActiveCall ? '120px' : '76px',
          minHeight: "calc(100vh)",
          paddingBottom: downloadAppBar ? '120px' : '',
        }}
      >

        <Outlet />

      </div>
      {/* <Footer /> */}
    </div>
  );
}

function Outerlayout() {
  return (
    <>
      {/* <OuterHeader /> */}



      <Outlet />

      {/* <OuterFooter /> */}
    </>
  );
}

export default Markup;
